module.exports = __webpack_public_path__ + "img/feedback_wrong_discount_light.9a0d9ea0.png";